<template>
  <div>
    <vue-table ref="vueTable" :table-data="tableData">
      <template slot="searchBar">
        <el-form-item label="时间范围">
          <date-range-picker :start.sync="tableData.search.start_at" :end.sync="tableData.search.end_at" width="240px" type="before"/>
        </el-form-item>
        <el-form-item label="登录状态">
          <el-select v-model="tableData.search.status" clearable>
            <el-option v-for="item in loginStatus" :key="item.id" :value="+item.id" :label="item.msg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="登录账号">
          <el-input v-model.trim="tableData.search.username" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="duration" slot-scope="{row}">
        <span>{{formatDuration(row.duration)}}</span>
      </template>
      <template slot="username" slot-scope="{row}">
        <span>{{row.username}}</span>
        <span v-if="row.admin && row.admin.name">({{row.admin.name}})</span>
      </template>
      <template slot="location" slot-scope="{row}">{{formatLocation(row)}}</template>
    </vue-table>
  </div>
</template>

<script>
import DateRangePicker from "@view/components/date/DateRangePicker.vue"
import {loginStatus} from "@utils/formatList";
export default {
  name: "log",
  components: {DateRangePicker},
  data() {
    return {
      loginStatus,
      tableData: {
        tableList: [],
        tableColumn: [
          { label: "登录时间", property: "create_at"},
          { label: "登录状态", property: "status", format: loginStatus, width: 100},
          { label: "登录账号", property: "username"},
          { label: "登录IP", property: "ip"},
          { label: "登录位置", property: "location"},
          { label: "浏览器", property: "browser"},
          { label: "操作系统", property: "os"},
          { label: "请求耗时", property: "duration"},
          { label: "备注", property: "remark"},
        ],
        search: {
          start_at: "",
          end_at: "",
          status: "",
          username: "",
        },
        api: "getLoginLog",
      },
    }
  },
}
</script>

<style scoped>

</style>
